import React from 'react';
import { PlanInterval, PlanTier } from '../graphql/generated/graphql';
import styles from './PricingModalTierLabel.module.scss';
import useAppSelector from '../app/redux/useAppSelector';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const PRICING_MODAL_TIER_LABEL_BILLING_TIER = gql(`
  fragment PricingModalTierLabelBillingTier on BillingTier {
    yearly {
      amount
    }
    monthly {
      amount
    }
  }
`);

const PRICING_MODAL_TIER_LABEL_BILLING_PRICING = gql(`
  fragment PricingModalTierLabel_billingPricing on BillingPricing {
    free {
      ...PricingModalTierLabelBillingTier
    }
    startup {
      ...PricingModalTierLabelBillingTier
    }
    business {
      ...PricingModalTierLabelBillingTier
    }
  }
`);

type BillingPricingFragment = DocumentType<
  typeof PRICING_MODAL_TIER_LABEL_BILLING_PRICING
>;

interface PricingModalTierLabelProps {
  tier: PlanTier;
  billingPricing?: BillingPricingFragment | null;
  interval: PlanInterval;
}

const getBillingTier = (
  billingPricing: BillingPricingFragment | null,
  tier: PlanTier,
): DocumentType<typeof PRICING_MODAL_TIER_LABEL_BILLING_TIER> | null => {
  if (!billingPricing) {
    return null;
  }
  switch (tier) {
    case PlanTier.Free:
      return billingPricing.free;
    case PlanTier.Startup:
      return billingPricing.startup;
    case PlanTier.Business:
      return billingPricing.business;
    default:
      return null;
  }
};

const PricingModalTierLabel = ({
  tier,
  billingPricing,
  interval,
}: PricingModalTierLabelProps) => {
  const isAdmin =
    useAppSelector((state) => state.session.user).type === 'ADMIN';

  const billingTier = getBillingTier(billingPricing ?? null, tier);

  const price =
    (interval === PlanInterval.Monthly
      ? (billingTier?.monthly.amount ?? 0)
      : (billingTier?.yearly.amount ?? 0)) / 100;

  return (
    <div className={styles.tierLabel}>
      <div className={styles.tierLabelTitle}>
        {tier === PlanTier.Free && 'Free'}
        {tier === PlanTier.Startup && 'Startup'}
        {tier === PlanTier.Business && 'Business'}
      </div>
      {isAdmin && (
        <div>
          <span className={styles.tierLabelPrice}>${price}</span>
          <span className={styles.tierLabelUser}>/user</span>
        </div>
      )}
    </div>
  );
};

export default PricingModalTierLabel;
